module.exports = __webpack_public_path__ + "static/img/16.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/sp/16.png
// module id = zj7G
// module chunks = 0